import themeConstants from '../../../../layout/Theme';

const styles = () => ({
  restaurantImg: {
    objectFit: 'cover',
    objectPosition: 'center',
  },
  restaurantRightBrand: {
    borderRadius: '24px 0px 0px 24px',
    backgroundColor: themeConstants.colors.contrastText,
    width: '150px',
    height: '150px',
  },
  logoImg: {},
  restaurantBrandComponent: {},
  button: {
    boxSizing: 'border-box',
    width: '200px',
    height: '60px',
    backgroundColor: themeConstants.colors.contrastText,
    color: '#000',
    fontWeight: 'bold',
    fontSize: '24px',
  },
  skeleton: {
    backgroundColor: themeConstants.colors.lightText,
    transform: 'unset',
  },
});

export default styles;
